<template>
    <section class="sessao-landing-page" id="galeria">
        <h2 class="titulo-padrao" data-aos="fade" data-aos-duration="1200">Galeria</h2>
        
        <section class="conteudo-sessao-landing-page">
            <img @click="$emit('abrir-imagem', imagem)"
                v-for="(imagem, index) in fotosPaginaAtual"
                :data-aos-delay="index * 200"
                data-aos="fade"
                data-aos-duration="1200"
                :key="index"
                :src="imagem"
                alt="Resultado de higienização"
                class="img-principal"
            >
        </section>

        <div class="indicador-pagina">
            <button class="seta" @click="paginaAnterior">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-arrow-narrow-left"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M5 12l14 0" /><path d="M5 12l4 4" /><path d="M5 12l4 -4" /></svg>
            </button>

            <button
                v-for="pagina in totalPaginas"
                :key="pagina"
                class="bola-pagina"
                :class="{ ativo: paginaAtual === pagina - 1 }"
                @click="irParaPagina(pagina - 1)"
            ></button>
            
            <button class="seta" @click="paginaProxima">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-arrow-narrow-right"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M5 12l14 0" /><path d="M15 16l4 -4" /><path d="M15 8l4 4" /></svg>
            </button>
        </div>
    </section>
</template>

<script>
import foto from "@/assets/banner.jpg";
import foto2 from "@/assets/ex.jpg";

export default{
    name: 'GaleriaLandingPage',
    data(){
        return{
            fotos: [
                foto,
                foto2,
                foto,
                foto2,
                foto,
                foto2,
                foto,
                foto2,
                foto
            ],

            paginaAtual: 0,
            fotosPorPagina: 3,
            intervalo: null
        }
    },

    computed: {
        totalPaginas() {
            return Math.ceil(
                this.fotos.length / this.fotosPorPagina
            )
        },

        fotosPaginaAtual() {
            const inicio =
                this.paginaAtual * this.fotosPorPagina

            const fim =
                inicio + this.fotosPorPagina

            return this.fotos.slice(inicio, fim)
        }

    },

    mounted() {
        this.iniciarCarrossel()
    },

    beforeUnmount() {
        clearInterval(this.intervalo)
    },

    methods: {
        iniciarCarrossel() {
            this.intervalo = setInterval(() => {
                this.paginaProxima()
            }, 5000)
        },


        paginaProxima() {
            if (this.paginaAtual >= this.totalPaginas - 1) {
                this.paginaAtual = 0
            } else {
                this.paginaAtual++
            }

        },


        paginaAnterior() {
            if (this.paginaAtual <= 0) {
                this.paginaAtual = this.totalPaginas - 1
            } else {
                this.paginaAtual--
            }
        },

        irParaPagina(pagina) {
            this.paginaAtual = pagina
        }

    }
}
</script>

<style scoped>
.sessao-landing-page{
    min-height: 100vh;
    width: 100%;
    padding: 42px 0;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 48px;
    border-bottom: solid 1px #12121232;
    border-radius: 10px;
}

.conteudo-sessao-landing-page{
    height: auto;
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    box-sizing: border-box;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 32px;
}

.img-principal{
    width: 100%;
    height: 70vh;
    object-fit: cover;
    border-radius: 5px;
    cursor: pointer;
    transition: all ease 0.4s;
}

.img-principal:hover{
    opacity: 0.7;
}

.titulo-padrao{
    font-size: 32px;
}

.indicador-pagina{
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
}

.bola-pagina{
    width: 10px;
    height: 10px;
    border-radius: 10px;
    background-color: rgba(255, 255, 255, 0.6);
    border: solid 1px var(--cor-tema);
    flex-shrink: 0;
}

.bola-pagina.ativo{
    background-color: var(--cor-tema);
}

.seta{
    width: 16px;
    height: 16px;
    border: none;
    background: none;
    color: var(--cor-tema);
    cursor: pointer;

}

@media (min-width: 768px) and (max-width: 1200px){
    .sessao-landing-page{
        padding: 42px 24px;
        min-height: auto;
    }

    .conteudo-sessao-landing-page{
        grid-template-columns: repeat(2, 1fr);
        gap: 8px;
    }
    .conteudo-sessao-landing-page .img-principal:last-child {
        grid-column: 1 / -1;
        height: 300px;
    }

    .img-principal{
        width: 100%;
        aspect-ratio: 1 / 1;
        height: 200px;
    }
}

@media (max-width: 600px){
    .sessao-landing-page{
        padding: 42px 24px;
        min-height: auto;
    }

    .titulo-padrao{
        font-size: 22px;
    }

    .conteudo-sessao-landing-page{
        grid-template-columns: repeat(2, 1fr);
        gap: 8px;
    }
    .conteudo-sessao-landing-page .img-principal:last-child {
        grid-column: 1 / -1;
        height: 180px;
    }

    .img-principal{
        width: 100%;
        aspect-ratio: 1 / 1;
        height: 180px;
    }
}
</style>